import * as form from '../form';

export const identificationBirthdate = (data = {}) => ({
  Date: form.datecontrol(data.Date),
  Confirmed: form.checkbox(data.Confirmed),
  EstimatedDateOfBirthExplanation: form.textarea(data.EstimatedDateOfBirthExplanation), // PVQ only
});
